import { t } from "@/locales";
import type { MenuRoute } from "@/shared/types/route";
import type { RouteRecordRaw } from "vue-router";

const layoutComponent = () => import("@/widgets/app-shell/AppShell.vue");

export const homepageRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "Root",
    component: layoutComponent,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/pages/dashboard/DashboardPage.vue"),
        meta: { title: "系统首页", localizedTitle: { "zh-CN": "系统首页", "zh-TW": "系統首頁" } },
      },
    ],
  },
];

export const homepageMenuRoutes: MenuRoute[] = [
  {
    path: "/dashboard",
    name: "Dashboard",
    get title() {
      return t("shell.home");
    },
    icon: "dashboard",
  },
];
